import styled from "@emotion/styled"
import { Menu } from "antd"
import "antd/dist/antd.css"
import SubMenu from "antd/lib/menu/SubMenu"
import { useState } from "react"
import { Link } from "react-router-dom"

export const MainMenu = () => {
    var path = window.location.pathname.substring(1)
    if (path.length === 0)
        path = 'homepage'
    const [selectedKeys, setSelectKeys] = useState(path)

    return <VMenu mode={"horizontal"} selectedKeys={[selectedKeys]} onClick={e => setSelectKeys(e.key)}>
        <VMenuItem key={"homepage"}><Link to={'/'}>首页</Link></VMenuItem>
        <VMenuItem key={"companyprofiles"}><Link to={'/companyprofiles'}>企业简介</Link></VMenuItem>
        <SubMenu key={'mainbusiness'} title={'主营业务'}>
            <VMenuItem key={"contentservice"}><Link to={'/contentservice'}>内容服务</Link></VMenuItem>
        </SubMenu>
        <VMenuItem key={"aboutus"}>关于我们</VMenuItem>
        <VMenuItem key={"contractus"}><Link to={'/contractus'}>联系我们</Link></VMenuItem>
    </VMenu>
}

const VMenu = styled(Menu)`
font-size: 1.5rem;
font-family: 微软雅黑;
min-width: 30vw;
margin-left: 5vw;
margin-right: 5vw;
`

const VMenuItem = styled(Menu.Item)`
height: 8rem;
padding-left: 3rem !important;
padding-right: 3rem !important;
`
